module.exports = __webpack_public_path__ + "static/logo-house-white-6bde4913fd384bfcdfbc09eb4b1bb2b3.png";